/** Entry-only handoff from signup; never overrides a folder or content link. */
export const FOLDER_FIRST_ONBOARDING_PARAM = 'onboarding';
export const FOLDER_FIRST_ONBOARDING_VALUE = 'folder';

export function isFolderFirstOnboardingEntry(url: URL): boolean {
  return /^\/dashboard\/(myorg|personal)\/?$/.test(url.pathname)
    && url.searchParams.get(FOLDER_FIRST_ONBOARDING_PARAM) === FOLDER_FIRST_ONBOARDING_VALUE
    && !hasContentIntent(url);
}

function hasContentIntent(url: URL): boolean {
  return ['continueDiagram', 'newFolder', 'starter', 'templateId', 'lt', 'invite', 'invitation', 'type', 'seed', 'path', 'forwardAuth']
    .some((key) => url.searchParams.has(key));
}

export function folderFirstOnboardingDestination(url: URL): string | null {
  if (!/^\/dashboard(?:\/(?:recent|myorg|personal))?\/?$/.test(url.pathname) || hasContentIntent(url)) {
    return null;
  }
  const target = new URL(url);
  target.pathname = url.pathname.includes('/personal') ? '/dashboard/personal' : '/dashboard/myorg';
  target.searchParams.delete('token');
  target.searchParams.set(FOLDER_FIRST_ONBOARDING_PARAM, FOLDER_FIRST_ONBOARDING_VALUE);
  target.searchParams.set('dashboard_ui', 'new');
  return `${target.pathname}${target.search}${target.hash}`;
}

/** Keep entry intent through SSO, without replaying an already consumed token. */
export function dashboardAuthReturnUrl(href: string): string {
  const url = new URL(href);
  url.searchParams.delete('token');
  return url.toString();
}
